import React from 'react';
import {
  useLocation,
} from 'react-router-dom';
import AdminRoutes from './admin_routes';
import UserRoutes from './user_routes';
import CustomerRoutes from './customer_routes';

export default function AppRoutes() {
  const { pathname } = useLocation();
  const platformContext = pathname.match(/^\/\w*/)[0];

  const contextsRoutes = {
    '/': <AdminRoutes />,
    '/admin': <AdminRoutes />,
    '/users': <UserRoutes />,
    '/customer': <CustomerRoutes />,
  };

  return (
    contextsRoutes[platformContext]
  );
}
